export const NEXT = "التالي";
export const FIRST_STEP_HEADER =
  "توثيق الهوية من خلال أبشر، اطرافنا موثقين لتجنب الاحتيال";
export const FIRST_STEP_DESCRIPTION =
  "يقوم وفي بتأكيد الهوية للأطراف من خلال التعامل مع خدمات حكومية مثل أبشر لتوثيق الحسابات";

export const SECOND_STEP_HEADER = "تم تأكيد قبول المنتج بنجاح";
export const SECOND_STEP_DESCRIPTION = "";
export const NAME = "يوسف الغامدي";
export const BUYER = "مشتري";
export const SECOND_STEP_HEADER_2 =
  " عملية الشراء كانت سهلة و أمنة جدا, و المنتج اتأكدت من جودنه و مطابقة قبل تحرير الفلوس و ارسالها للبائع";
export const SECOND_STEP_HEADER_3 =
  "استلم المنتج بافضل جودة، واستلم مبلغ المعاملة بأمان وسهولة";
export const SECOND_STEP_DESCRIPTION_2 =
  "تأكد من جودة مشترياتك وفي حالة النزاع فريق التحكيم المتخصص سيقوم بتسوية الموقف سريعا بعدل وشفافية";
export const THIRD_STEP_HEADER =
  "إن كنت بائع أو مشتري نحمي\n كل معاملاتك ونحفظ حقك";
export const THIRD_STEP_DESCRIPTION =
  "نحمي مشترياتك ومبيعاتك لضمان الجودة المتفق عليها ونأمن المدفوعات ولا نحررها إلا بعد التحقق من صحتها ";
export const FOURTH_STEP_HEADER =
  "ابدءمعاملاتك من خلال مجموعة من اقسامنا المدعومة";
export const FOURTH_STEP_DESCRIPTION =
  "ندعم أقسام سوق المستعمل: عقارات، سيارات، أجهزة كهربائية منزلية والأثاث بالإضافة إلي عقود الخدمات الحرة مثل: التصميم والبرمجة";
